import { render, staticRenderFns } from "./CategoryCreateEditDialog.vue?vue&type=template&id=0fd6453a&scoped=true"
import script from "./CategoryCreateEditDialog.vue?vue&type=script&lang=js"
export * from "./CategoryCreateEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryCreateEditDialog.vue?vue&type=style&index=0&id=0fd6453a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6453a",
  null
  
)

export default component.exports